/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import './index-6f6b9acc.js';

/**
 * 安全 JSON.parse
 *
 * @param {string} str 需要 JSON.parse 的字符串
 * @returns {object|null} JSON.parse 返回的值
 */
var safeJSONParse = function (str) {
    try {
        return JSON.parse(str);
    }
    catch (error) {
        return null;
    }
};

export { safeJSONParse as s };
